<template>
  <div class="user__activity">
    <div class="user__topups box p-3">
      <h3 class="text-center">Lịch sử nạp tiền</h3>

      <b-table
        striped
        hover
        :items="deposits"
        :fields="depositFields"
        :busy="isLoadingTransaction"
        show-empty
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:empty="scope">
          <h6 class="text-center">Không có dữ liệu</h6>
        </template>
        <template v-slot:emptyfiltered="scope">
          <h6 class="text-center">Không có dữ liệu</h6>
        </template>
        <template v-slot:cell(type)="data">
          <span>{{ data.item.type }}</span>
          <template v-if="data.item.status == 'Chưa hoàn thành'">
            ( <b-link v-b-modal.modal-cod>Nhập mã</b-link> )
          </template>
        </template>
        <template v-slot:cell(created_at)="data">
          <span>{{ data.item.created_at | formatDate }}</span>
        </template>
      </b-table>
    </div>

    <div class="user__topups box p-3">
      <h3 class="text-center">Lịch sử thanh toán</h3>

      <b-table
        striped
        hover
        :items="transactions"
        :fields="transactionFields"
        :busy="isLoadingTransaction"
        show-empty
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:empty="scope">
          <h6 class="text-center">Không có dữ liệu</h6>
        </template>
        <template v-slot:emptyfiltered="scope">
          <h6 class="text-center">Không có dữ liệu</h6>
        </template>
      </b-table>
    </div>

    <div class="user__exams box p-3">
      <h3 class="text-center">Lịch sử mua đề</h3>

      <b-table
        striped
        hover
        :items="exams"
        :fields="examFields"
        :busy="isLoadingExam"
        show-empty
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:empty="scope">
          <h6 class="text-center">Không có dữ liệu</h6>
        </template>
        <template v-slot:emptyfiltered="scope">
          <h6 class="text-center">Không có dữ liệu</h6>
        </template>
        <template v-slot:cell(exam)="data">
          <b-link
            v-if="data.item.status"
            class="text-red"
            :to="{
              name: 'exam-detail',
              params: { id: data.item.exam_id, slug: data.item.exam.slug }
            }"
            >{{ data.item.exam.name }}</b-link
          >
          <span v-if="!data.item.status">{{ data.item.exam.name }}</span>
        </template>
      </b-table>
    </div>
    <b-modal
      id="modal-cod"
      @ok="handleOk"
      title="Hoàn thanh giao dịch COD"
    >
      <b-form @submit="onSubmit">
        <b-form-group
          id="input-group-cod"
          label="Mã COD:"
          label-for="input-cod"
          description="Vui lòng nhập mã COD bạn nhận được"
        >
          <b-form-input
            id="input-cod"
            v-model="form.cod"
            type="text"
            required
          ></b-form-input>
        </b-form-group>
      </b-form>

      <template v-if="codStatus == 'error'">
        <span class="text-danger">{{ codMessage }}</span>
      </template>
      <template v-else>
        <span class="text-success">{{ codMessage }}</span>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { STORE_KEY } from "../_store/constants";

export default {
  name: "UserActivity",
  data() {
    return {
      form: {
        cod: ""
      },
      depositFields: [
        {
          key: "created_at",
          label: "Ngày"
        },
        {
          key: "amount",
          label: "Số tiền",
          formatter: (value) => {
            return value.toLocaleString() + " VNĐ";
          }
        },
        {
          key: "status",
          label: "Trạng Thái",
          tdClass: (value) => {
            return value == "Chưa hoàn thành" ? "text-warning" : "text-success";
          }
        },
        {
          key: "type",
          label: "Hình thức thanh toán"
        }
      ],
      transactionFields: [
        {
          key: "created_at",
          label: "Ngày"
        },
        {
          key: "amount",
          label: "Số tiền",
          formatter: (value,) => {
            return value.toLocaleString() + " VNĐ";
          }
        },
        {
          key: "note",
          label: "Nội dung"
        }
      ],
      examFields: [
        {
          key: "created_at",
          label: "Ngày"
        },
        {
          key: "price",
          label: "Số tiền",
          formatter: (value) => {
            return value.toLocaleString();
          }
        },
        {
          key: "status",
          label: "Trạng Thái",
          formatter: (value) => {
            return value ? "Hoàn thành" : "Chờ xét duyệt";
          },
          tdClass: (value) => {
            return value ? "text-success" : "text-warning";
          }
        },
        {
          key: "exam",
          label: "Đề thi"
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      transactions: `${STORE_KEY}/transactions`,
      deposits: `${STORE_KEY}/deposits`,
      exams: `${STORE_KEY}/exams`,
      isLoadingExam: `${STORE_KEY}/isLoadingExam`,
      isLoadingTransaction: `${STORE_KEY}/isLoadingTransaction`,
      codStatus: `${STORE_KEY}/codStatus`,
      codMessage: `${STORE_KEY}/codMessage`
    })
  },
  beforeMount() {
    this.userExams();
    this.getTransactions();
    this.getDeposits();
  },
  methods: {
    ...mapActions(`${STORE_KEY}`, [
      "getDeposits",
      "getTransactions",
      "userExams",
      "confirmCOD"
    ]),
    onSubmit() {
      this.confirmCOD({ code: this.form.cod });
    },
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();

      this.confirmCOD({ code: this.form.cod });

      this.$nextTick(() => {
        this.$bvModal.hide('modal-prevent-closing')
      })
    }
  },
  watch: {
    codStatus: function(value) {
      if (value == 'error') {
        //
      }
    }
  }
};
</script>
